'use client'

import { SupportForm } from '@/components/SupportForm'

/**
 * Feedback button that opens the custom support form popover.
 */
export function FeedbackButton({ triggerVariant = 'default' }: { triggerVariant?: 'default' | 'menu-item' }) {
  return <SupportForm triggerVariant={triggerVariant} />
}
